import { render, staticRenderFns } from "./Supports.vue?vue&type=template&id=0d8816f7&scoped=true"
import script from "./Supports.vue?vue&type=script&lang=ts"
export * from "./Supports.vue?vue&type=script&lang=ts"
import style0 from "./Supports.vue?vue&type=style&index=0&id=0d8816f7&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8816f7",
  null
  
)

export default component.exports